export default {
  admin: 'Әкімші',
  iin: 'ЖСН',
  ecp: 'ЭЦП',
  user_iin: 'Пайдаланушының ЖСН-і',
  personnel_number: 'Табельдік нөмірі',
  photo: 'Фотосуреті',
  photos: 'Суреттері',
  password: 'Құпиясөз',
  login: 'Логині',
  user_name: ' Пайдаланушының аты',
  sign_in: 'Кіру',
  logout: 'Шығу',
  main: 'Басты бет',
  all_name: 'Барлығы {name} ',
  optional: 'опциялық',
  date: 'Күні',
  time: 'Уақыты',
  login_for_auth: 'Авторластыру үшін логин',
  password_for_auth: 'Авторластыру үшін құпиясөз',
  min: 'мин',
  type: 'Түрі',
  number: 'Нөмірі',
  accept_entire_region: 'Барлық өңірді қабылдау ',
  FIO_long: 'Тегі Аты Әкесінің аты',
  fio_small: 'ТАӘ',
  testing_started: 'Тестілеу басталды',
  accept: 'Қабылдау',
  reject: 'Қабылдамау',
  rejected: 'Қабылданбады',
  user_fio: 'Пайдаланушының ТАӘ',
  nomination: 'Атауы',
  nomination_plan: 'Курстың атауы',
  nomination_theme: 'Тақырыптың атауы',
  nomination_test: 'Тест атауы',
  nomination_package: 'Пакеттің атауы',
  nomination_exam: 'Емтихан атауы',
  nomination_webinar: 'Вебинар атауы',
  nomination_lesson: 'Сабақтың атауы',
  nomination_certificate: 'Сертификат атауы',
  nomination_audience: 'Аудитория атауы',
  nomination_file: 'Файл атауы',
  file: 'Файл',
  every_auth_date: 'әрбір авторластыру күні',
  registration_datetime: 'тіркеу күні мен уақыты',
  list_attached_exams: 'бекітілген емтихандар тізімі',
  theme: 'Тақырыбы',
  exam_date: 'Емтихан күні',
  theme_type: 'Тақырып түрі',
  theme_1: 'Тақырыптама',
  duration: 'Ұзақтығы',
  duration_1: ' Ұзақтығы ',
  duration_2: ' Ұзақтығы',
  condition_passing: 'Өту талаптары',
  condition_passing_test: 'дұрыс жауаптар % (0-ден 100%-ға дейін)',
  status: 'Мәртебесі',
  materials: 'материалдар',
  educationPlan: 'Курс',
  plan: 'Курс',
  planName: 'Курс атауы',
  name: 'Атауы',
  name_1: 'Аты',
  themeName: 'Тақырып атауы',
  new_exam: 'Жаңа емтихан',
  themes: 'Тақырыптар',
  verification_method: 'Тексеру тәсілі',
  subdivision: 'Бөлімше',
  subject: 'Пән',
  certificate: 'Сертификат',
  mew_certificate: 'Жаңа сертификат',
  change_certificate: 'Сертификатты өзгерту',
  professions_list: 'Кәсіптер тізбесі',
  exam: 'Емтихан',
  download: 'Жүктеу',
  education_type: 'Оқыту түрі',
  education_plan_description: 'Курстың сипаттамасы',
  short_description: 'Қысқаша сипаттамасы',
  education_type_1: 'Оқыту түрі',
  hour: 'Сағ. | Сағаты | Сағаттары',
  walkthrough: 'Өту',
  thematic_plan: 'Тақырыптық курс',
  more: 'Егжей-тегжейлі',
  check_type: 'Тексеру түрі',
  about_theme: 'Тақырып туралы',
  theme_info: 'Тақырып туралы ақпарат',
  lesson_type: 'Сабақ түрі',
  lesson_plan: 'Сабақ жоспары',
  outline: 'Мазмұндау жоспары',
  benefits: 'Оқу құралы',
  equipment: 'Жабдық',
  about_test: 'Тест туралы',
  test_info: 'Тест туралы ақпарат',
  conditions_passage: 'Өту талаптары',
  industrial: 'Өндірістік',
  industrial_1: 'Өндірістік',
  theoretical: 'Теориялық',
  theoretical_1: 'Теориялық',
  exams_and_tests: 'Емтихандар мен тестілер',
  tests: 'Тестілер',
  new_test: 'Жаңа тест',
  questions: 'Сұрақтар',
  question_text: 'Сұрақ мәтіні',
  retakes: 'Қайта тапсырулар',
  retake_date: 'Қайта тапсыру күні',
  retake_time: 'Қайта тапсыру уақыты',
  new_retake: 'Жаңа қайта тапсыру',
  description: 'Сипаттамасы',
  terms: 'Талаптары',
  question: 'Сұрақ | Сұрақ | Сұрақтар',
  test: 'Тест | Тест | Тестілер',
  results: 'Нәтижелер',
  result: 'Нәтиже',
  passed: 'Өтті',
  average_result: 'Орташа нәтиже',
  start_testing: 'Тестілеуді бастау',
  completed_exam: 'Емтиханды ақтағандар',
  testing: 'Тестілеу',
  of: 'шыққан',
  hrs: 'сағ.',
  start_exam: 'Емтихан',
  start: 'Бастау',
  exams: 'Емтихан',
  exams_ml: 'Емтихандар',
  examiners: 'Емтихан алушылар',
  completed: 'Аяқталды',
  complete_webinar: 'Вебинарды аяқтау',
  share_screen: 'Экранмен бөлісу',
  off_share_screen: 'Экранның көрсетілімін ажырату',
  watch_now: 'Қазір қарап отырғандар',
  examiner: 'Емтихан алушы',
  change_examiner: 'Емтихан алушыны өзгерту',
  new_examiner: 'Жаңа емтихан алушы',
  examiner_fio: ' Емтихан алушының Т.А.Ә.',
  examiner_fio_1: 'Вебинар өткізушінің Т.А.Ә.',
  surname: 'Тегі',
  examiner_surname: 'Емтихан алушының тегі',
  examiner_name: 'Емтихан алушының аты',
  examiner_middle_name: 'Емтихан алушының әкесінің аты',
  middle_name: 'Әкесінің аты',
  examiner_iin: 'Емтихан алушының ЖСН',
  examiner_login: 'Емтихан алушының нөмірі',
  examiner_password: 'Емтихан алушының құпия сөзі',
  examiner_name_surname: 'Емтихан алушының Аты Тегі',
  exam_start_date: 'Емтиханның басталу күні',
  passed_start_exam: 'Емтихан басталғаннан бері өтті',
  password_for_ecp: 'ЭСҚ үшін құпиясөз',
  report_card: 'Табель',
  sign_ecp: 'ЭСҚ-мен қол қою',
  admin_report_card: 'Әкімшінің табелі',
  analytic: 'Талдау',
  exam_analytic: 'Емтиханды талдау',
  topics_wrong_answers: 'Тақырыптар бойынша дұрыс емес жауаптар ',
  topics_right_answers: 'Тақырыптар бойынша дұрыс жауаптар ',
  current_webinars: 'Ағымдағы вебинарлар',
  all_webinars: 'Барлық вебинарлар',
  webinars: 'Вебинарлар',
  webinar_date: 'Вебинар күні',
  lesson_date: 'Сабақтың күні',
  teacher_fullname: 'Өткізушінің Т.А.Ә.',
  live_stream: 'Тікелей трансляция',
  watch_record: 'Жазбаны қарау',
  webinar_start_date: 'Вебинардың басталу күні',
  start_date: 'Басталу күні',
  webinar_beginner_time: 'Вебинар басталғаннан бері өткен уақыт',
  until_webinar: 'Вебинар аяқталғанға дейін',
  ask_question: 'Сұрақ қою',
  connect: 'Қосылу',
  coming_webinar: 'Алдағы вебинарлар',
  will_start: 'Басталуына қалды',
  camera: 'Камера',
  face_not_recognized: 'Тұлға танылмады',
  cancel: 'Жою',
  image: 'Кескін',
  important: 'Маңызды',
  check_camera: ['Камераның жұмыс істеп тұрғанына көз жеткізіңіз', 'Камераға тура қараңыз', 'Сізді жүйе танығанша күтіңіз'],
  past_webinar: 'Вебинардан өткендер',
  scorm_package: 'Scorm пакеттер',
  scorm_package_1: 'scorm пакеттер',
  not_passed: 'Өткен жоқсыз',
  run: 'Іске қосу',
  scormPackageIframe: 'Еңбекті қорғау, өнеркәсіптік қауіпсіздік және қоршаған ортаны қорғау бойынша кіріспе курс',
  mediafiles: 'Медиафайлдар',
  create_mediafile: 'Жаңа медиафайл',
  change_mediafile: 'Медиафайлды өзгерту',
  prev: 'Артқа',
  next: 'Алға',
  remove: 'Өшіру',
  region: 'Өңір',
  exam_result: 'Емтихан нәтижелері',
  question_count: 'Сұрақтар саны',
  test_duration: 'Тестінің ұзақтығы',
  webinar_duration: 'Вебинардың ұзақтығы',
  lesson_duration: 'Сабақтың ұзақтығы',
  minute: 'Минут | Минуттар | Минут',
  before_exam_end: 'Емтихан аяқталғанға дейін',
  complete_exam: 'Емтиханды аяқтау',
  test_time_up: 'Тестілеу уақыты бітті!',
  testing_time: 'Тестілеу уақыты',
  ok: 'Окей',
  webinar_testing_desc: 'Вебинар уақытында бірнеше тестілеу өткізілуі мүмкін',
  webinar_time: 'Вебинар уақыты',
  lesson_time: 'Сабақ уақыты',
  no_message: 'Әзірге хабарлама жоқ',
  upload_file: 'Файлды жүктеу',
  uploading: 'Жүктейміз',
  write: 'Жазу',
  close: 'Жабу',
  webinar_chat: 'Вебинар бойынша чат',
  webinar_name: 'Вебинар атауы',
  webinar_question_for: 'Вебинар бойынша сұрақ',
  send: 'Жіберу',
  answer: 'Жауап',
  change_password: 'Құпиясөзді өзгерту',
  current_password: 'Ағымдағы құпиясөз',
  new_password: 'Жаңа жұпиясөз',
  repeat_new_password: 'Жаңа құпиясөзді қайталаңыз',
  password_mismatch: 'Құпиясөздер сәйкес келмейді',
  save: 'Сақтау',
  statistics: 'Статистика',
  visits_log: 'Кірулер журналы',
  users: 'Пайдаланушылар',
  video_lessons: 'Бейне сабақтар',
  video_lesson: 'Бейне сабақ',
  not_completed_video_lesson: 'Өтілмеген бейне сабақтар',
  completed_video_lesson: 'Өтілген бейне сабақтар',
  create_webinar: 'Вебинарды құру',
  create_webinar_1: 'Вебинарды құру',
  create_lesson: 'Бейне сабақты құру',
  update_lesson: 'Бейне сабақты редакциялау',
  create: 'Құру',
  webinar_teachers: 'Өткізілетін вебинарлар',
  webinar: 'Вебинар',
  webinar_questions: 'Вебинар бойынша сұрақтар',
  admin_questions: 'Әкімші сұрақтары',
  certificates: 'Сертификаттар',
  roles: 'Рольдер',
  audience_exam: ' Аудитория емтихандары',
  new_audience_exam: 'Емтиханның жаңа аудиториясы',
  change_audience_exam: 'Емтиханның аудиториясын өзгерту',
  audience: 'Аудитория',
  download_report: 'Есепту жүктеу',
  course_attendance: 'Курстарға қатысым',
  test_turnout: 'Тестке келу',
  received_certification: 'Сертификат алғандар',
  download_excel: ' Excel-ді жүктеу ',
  education_theme: 'Оқу тақырыбы',
  item_list: 'Пәндер тізбесі',
  visit: 'Қатысым',
  education_times: 'Оқу сағаты',
  position: 'Лауазымы',
  position_1: 'Позиция',
  select_position: 'Лауазымды таңдаңыз',
  user_type: 'Пайдаланушы түрі',
  time_sheet: 'Табельдік',
  auth_date: 'Авторластыру күні <br>',
  retake: 'Қайта тапсыру',
  assign_retake: 'Қайта тапсыруды белгілеу ',
  assign_retakes_list: 'Белгіленген қайта тапсырулар тізімі',
  assign: 'Белгілеу',
  import_database: 'Деректер қорын алу',
  create_user: 'Пайдаланушыны құру',
  registration_date: 'Тіркеу күні',
  create_recording_webinar: 'Вебинар өткізушінің жазбаны құрған күні',
  change_recording_webinar: 'Вебинар өткізушінің жазбаны өзгертуі',
  webinar_started_through: 'Вебинарды бастауға болады',
  teacher_login: 'Өткізуші логині',
  availability_photo: 'Фотосуреттің бар-жоғы',
  timetable: 'Кесте',
  user_photos: 'Пайдаланушының фотосуреттері',
  upload_photo: 'Фотосуретті жүктеу',
  upload: 'Жүктеу',
  attach_plan: 'Курсты бекіту',
  attach: 'Бекіту',
  block: 'Бұғаттау',
  unlock: 'Бұғаттан алу',
  deleteUser: 'Өшіру',
  gradebook: 'Үлгерім журналы',
  hours_cnt: 'Сағат саны',
  new_user: 'Жаңа пайдаланушы',
  change_webinar: 'Вебинарды өзгерту',
  max_upload: 'Файлдың ең жоғарғы өлшемі{size}',
  max_uploads: 'Әрбір файлдың ең жоғарғы өлшемі {size}',
  max_upload_video: 'Бейне {size}',
  upload_one_file: '1 файлды жүктеңіз',
  upload_multiple: 'Бірнеше файлды жүктеуге болады',
  size: {
    mb: 'Мегабайт'
  },
  export: 'Экспорт',
  export_users: 'Пайдалануылар экспорты',
  import: 'Импорт',
  create_plan: 'Курсты құру',
  change_plan: 'Курсты өзгерту',
  change: 'Өзгерту',
  occupational_professions: 'кәсіптер',
  themes_count: 'Тақырыптар саны',
  students: 'Білім алушылар',
  education_plan_name: 'Курстың атауы',
  exam_type: 'Емтихан түрі',
  new_theme: 'Жаңа тақырып',
  change_theme: 'Тақырыпты өзгерту',
  theme_number: 'Тақырыптың нөмірі',
  training_number: 'Курстағы реттік нөмірі',
  serial_number: 'Реттік нөмірі',
  theme_description: 'Тақырыптың сипаттамасы',
  new_material_outline: 'Жаңа материалды мазмұндау жоспары',
  list_equipment_used: 'Қолданылатын жабдықтар тізбесі ',
  list_educational_aids: 'Оқу-көрнекі құралдар тізбесі',
  count_hours_study: 'Оқыту сағаттарының саны ',
  test_relate_webinar: 'Тест бойынша вебинар',
  change_test: 'Тестіні өзгерту',
  new_question: 'Жаңа сұрақ',
  change_question: 'Сұрақты өзгерту',
  possible_answer: 'Жауаптың нұсқасы',
  correct_answer: 'Дұрыс жауап',
  class_room: 'Сынып',
  change_retake: 'Қайта тапсыруды өзгерту',
  update: 'Жаңарту',
  enter: 'Енгізіңіз',
  exam_audience: 'Емтихан аудиториясы',
  exam_time: 'Емтихан уақыты',
  change_exam: 'Емтиханды өзгерту',
  kazlang: 'Қазақ тілі',
  math: 'Математика',
  search_request: 'Ізделетін сұрау',
  search: 'Іздеу',
  error: 'Қате',
  day_locale: {
    'Mon': 'ДС',
    'Tue': 'СС',
    'Wed': 'СР',
    'Thu': 'БС',
    'Fri': 'ЖМ',
    'Sat': 'СБ',
    'Sun': 'ЖС'
  },
  month_locale: {
    'Jan': 'Қаңтар',
    'Feb': 'Ақпан',
    'Mar': 'Наурыз',
    'Apr': 'Сәуiр',
    'May': 'Мамыр',
    'Jun': 'Маусым',
    'Jul': 'Шiлде',
    'Aug': 'Тамыз',
    'Sep': 'Қыркүйек',
    'Oct': 'Қазан',
    'Nov': 'Қараша',
    'Dec': 'Желтоқсан'
  }

}



// WEBPACK FOOTER //
// /src/i18n/kz.js